// 1. IMPORTS
import moment from 'moment'
import mock from '../mock'
import { STATION_WARNINGS_ENDPOINT } from '../../services/stationWarningsService'
import { getDatesInMonth } from '../../helper/UtilsFunctionsDate'

// 2. CONSTANTS
const DAILY_WARNING_COUNTS = {
  THIS_MONTH: [4, 7, 2, 0, 5, 9, 3, 6, 2, 4, 8, 3, 1, 5, 11, 4, 2, 6, 3, 0, 7, 5, 2, 4, 8, 3, 6, 1, 4, 2, 5],
  LAST_MONTH: [7, 3, 9, 5, 2, 6, 11, 4, 8, 3, 6, 5, 2, 9, 4, 7, 3, 10, 6, 4, 8, 2, 5, 7, 3, 6, 4, 9, 2, 5, 3]
}
const MONTH_UNIT = 'month'

// 4. MOCK API
// Deterministic station warning events, currently camera samples only.
// Counts represent warning events, not currently offline devices.
mock.onGet(STATION_WARNINGS_ENDPOINT).reply(() => {
  const thisMonthDates = getDatesInMonth(moment(), true)
  const lastMonthDates = getDatesInMonth(moment().subtract(1, MONTH_UNIT))
  return [200, {
    thisMonth: thisMonthDates.map((date, index) => ({ date, warningCount: DAILY_WARNING_COUNTS.THIS_MONTH[index] })),
    lastMonth: lastMonthDates.map((date, index) => ({ date, warningCount: DAILY_WARNING_COUNTS.LAST_MONTH[index] }))
  }]
})